import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ValidationIconComponent } from '@src/app/components/input/validation-icon/validation-icon.component.js'

@NgModule({
  declarations: [ValidationIconComponent],
  imports: [CommonModule],
  exports: [ValidationIconComponent],
})
export class ValidationIconComponentModule {}
